module.exports = __webpack_public_path__ + "static/media/star-ns.a5bbef6c.png";